exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ApcuGIchar1erIgolK4Wa{fill:\"[theme:neutralPrimary, default:#333333]\";width:30px!important;height:22px!important}html[dir=ltr] .ApcuGIchar1erIgolK4Wa{margin-right:-9px}html[dir=rtl] .ApcuGIchar1erIgolK4Wa{margin-left:-9px}", ""]);
// Exports
exports.locals = {
	"proofingIcon": "ApcuGIchar1erIgolK4Wa"
};